import { useSelector, useDispatch } from 'react-redux';
import { ScreenPreview } from "./";
import { ClientField } from "../fields";
import { DeleteButton } from "../client/DeleteButton";
import { deleteLoopEntry } from "../../store/actions/client";
import { clientEntriesSelector } from "../../store/selectors/clientEntries";
import { ignoreConditionsSelector, disableRequiredSelector } from "../../store/selectors/clientSettings";
import { applyValidations } from "../../lib/fields";
import { conditionsSelector } from "../../store/selectors/entities/conditions";
import { conditionCheck } from "../../lib/conditions";
export const AdvancedLoopScreenItem = ({
  keyField,
  allowDuplicates = false,
  subSheetScreens,
  rowGuid,
  loopItems,
  setLoopItems
}) => {
  const dispatch = useDispatch();
  const previewEntries = useSelector(clientEntriesSelector);
  const conditions = useSelector(conditionsSelector);
  const ignoreConditions = useSelector(ignoreConditionsSelector);
  const disableRequired = useSelector(disableRequiredSelector);
  const loopItemEntries = previewEntries.filter(entry => `${entry.rowGuid}` === `${rowGuid}`).map(entry => ({
    ...(!entry.keyField ? applyValidations(entry, {
      disableRequired
    }) : entry),
    conditionMet: ignoreConditions ? true : conditionCheck(entry.guid, previewEntries, conditions)
  }));
  const keyFieldEntry = loopItemEntries.find(entry => `${entry.id}` === `${keyField.id}`);

  // returns an array of currently selected options for the keyfield when allow_duplicates is set to false for the screen
  // this is used to prevent duplicate options being selected when the keyfield is a dropdown and contains reference data
  const currentlySelectedOptions = !allowDuplicates ? previewEntries.filter(entry => entry.id === keyField.id && entry.rowGuid && entry.value).map(entry => entry.value) : [];
  const renderSubSheetEntries = rowGuid => subSheetScreens.map(subSheetScreen => {
    const isNestedLoop = subSheetScreen.subSheet.sheet_type_id == 13;
    const subSheetEntries = loopItemEntries.filter(entry => `${entry.sheet_id}` === `${subSheetScreen.subSheet.id}`);
    return <div key={`${subSheetScreen.subSheet.id}-${rowGuid}`} className="advanced-loop-screen--loop-item-subscreen">
          <ScreenPreview entries={subSheetEntries} />
          {isNestedLoop && <div className="foundry--surface surface--info nested-loop--unsupported-message">
              <div className="alert--icon">
                <i className="foundry-icon icon--info icon--solid"></i>
              </div>
              <div>Nested Loops are not supported for pre-fill.</div>
            </div>}
        </div>;
  });
  return <div key={rowGuid} className="advanced-loop-screen--loop-item">
      <div className="advanced-loop-screen--loop-item-delete">
        <DeleteButton onConfirm={() => {
        setLoopItems(loopItems.filter(loopItem => `${loopItem}` !== `${rowGuid}`));
        dispatch(deleteLoopEntry({
          activeRowGuid: rowGuid
        }));
      }} />
      </div>
      <div className="advanced-loop-screen--loop-item-entries">
        <ClientField entry={{
        ...keyFieldEntry,
        removeDuplicates: !allowDuplicates,
        currentlySelectedOptions
      }} />
        {renderSubSheetEntries()}
      </div>
    </div>;
};